﻿import { expressQuerySelector } from "../common/html";
import { subscribeAsync } from "../services/account-service";
import { initForm } from "./form";
import { createPopup } from "./popup-new";

export function initLeaveIntent() {
	const toggleLeaveIntent = (enable: boolean) => { if (typeof window.enableLeaveIntent !== "undefined") window.enableLeaveIntent = enable; };
	const isLeaveIntentEnabled = (): boolean => window.enableLeaveIntent && window.location.search.indexOf("embed") < 0;
	const getLeaveIntentType = () => {
		return window.dataLayerSite[0].accountType === 'full' || window.dataLayerSite[0].accountType === 'guest'
			? window.dataLayerSite[0].optIn === true ? '' : window.dataLayerSite[0].existing === true ? 'A' : 'B'
			: window.dataLayerSite[0].returning === true ? window.dataLayerSite[0].existing === true ? 'C' : 'D' : 'E';
	};
	const triggerLeaveIntentPopup = () => {
		const type = getLeaveIntentType();
		if (!type) return;

		createPopup({
			dialogId: 'leave-intent-dialog',
			view: 'GenericPopup',
			data:
			{
				ExtraHeaderCss: 'm-popup__header--custom',
				ExtraPopupCss: 'p-leave-intent',
				BodyLabel: `Label.LeaveIntentPopup.Dialog${type}`
			}
		}).then(popup => {
			if (!popup.popup) return;
			const formEl = expressQuerySelector<HTMLFormElement>(popup.popup, "#leaveIntentPopupForm", true);
			const emailEl = [].slice.call(formEl.elements)[0] as HTMLInputElement;

			emailEl.setAttribute('email', 'email');
			emailEl.setAttribute('required', 'required');

			initForm(formEl, {
				submitOnEnter: true,
				onSubmitForm: (data: { [inputName: string]: string }): Promise<void> => subscribeFormSubmit(data, popup.popup, formEl),
				buttonSelector: '#leaveIntentPopupButton'
			});

			popup.openAsync();
		});
	};
	const subscribeFormSubmit = (data: { [inputName: string]: string }, popupEl: HTMLElement, formEl: HTMLElement): Promise<void> => {
		const successMessageEl = expressQuerySelector<HTMLFormElement>(popupEl, "#leaveIntentPopupDone", true);
		const sourceInputEl = expressQuerySelector<HTMLInputElement>(popupEl, "#leaveIntentPopupSource", true);
		const email = data['leaveintentpopupemail'];

		return subscribeAsync(
			email === 'email@email.com' ? '' : email,
			window.dataLayerSite[0].appId,
			window.dataLayerSite[0].posId,
			window.dataLayerSite[0].language,
			sourceInputEl.value
		).then(() => {
			// show success and hide form => The popup body is a label so special case for show hide
			if (successMessageEl.offsetParent === null)
				successMessageEl.style.display = successMessageEl.style.display === 'none' ? '' : getComputedStyle(successMessageEl).display === 'none' ? 'block' : '';
			formEl.style.display = 'none';
		});
	};
	const init = (forceEnable?: boolean) => {
		if (!isLeaveIntentEnabled() && !forceEnable) return;

		try {
			ouibounce(false, {
				sensitivity: 20,
				aggressive: false,
				sitewide: true,
				timer: 1000,
				delay: 100,
				callback: triggerLeaveIntentPopup,
				cookieExpire: 1,
				canFire: isLeaveIntentEnabled
			});
		} catch (exc) {
			// Adblocker probably blocked ouiBounce from loading.
		}
	};

	init(false);

	return {
		EnableLeaveIntentPopup: () => init(true),
		EnableLeaveIntent: () => toggleLeaveIntent(true),
		DisableLeaveIntent: () => toggleLeaveIntent(false)
	};
}
